import BloodSetEditor from "./BloodsGenerator";
import BloodResultsViewer from "./BloodsViewer";
import { makeId } from '../../utils/generateid';
import { useEffect } from 'react';

export default function ScenarioBloodsForm({ data = [], onChange }) {

    useEffect(() => {
        if (!Array.isArray(data)) return;
        const needsIds = data.some(s => !s?.id);
        if (!needsIds) return;
        const withIds = data.map(s => (s?.id ? s : { ...s, id: makeId() }));
        onChange?.(withIds);
    }, [data, onChange]);

    return (
        <div style={{display: 'flex', flexDirection: 'row', gap: '1rem', justifyContent: 'center',}}>
        <div className='historic-bloods' style={{textAlign: 'center', border: '1px solid lightgrey', borderRadius: '6px', minWidth: '250px', width: '90%', padding: '1rem',}}>
            <div style={{ marginBottom: '1rem' }}>
            <div
                style={{paddingBottom: '10px', marginBottom: '10px', borderBottom: '1px solid lightgrey'}}>
                Use this section to add scenario blood results. These can be sent to the participant during the scenario via the facilitator dashboard. You can also add/edit blood results during the live scenario if required.
            </div>
            <BloodSetEditor data={data} onChange={(updated) => {
                onChange(updated)
            }} showTimestampPicker={false} buttonLabel='Add to scenario'/>
            </div>

            <div style={{ marginTop: '2rem', borderTop: '1px solid #ccc', paddingTop: '1rem' }}>
            <h3>Existing Entries</h3>
            <BloodResultsViewer
                bloodSets={data || []}
                onChange={(updated) => onChange(updated)}
                isScenarioBloods={true}
            />
            </div>
        </div>
        </div>
    );
}